//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet } from '../../axios/axios.js'
import { prepareReportWork } from './Report.js'
import ReportMultiReportSelector from './ReportMultiReportSelector.vue'
import Table from '../../components/Table/Table.vue'
import WarningBanner from '../../components/WarningBanner.vue'
import RequestWorkTypeIncludedInWorkPackagesIndicator from './../Request/RequestWorkTypeIncludedInWorkPackagesIndicator.vue'
import RequestWorkTypeDoneIndicator from './../Request/RequestWorkTypeDoneIndicator.vue'

function deleteElementFromArray (array, element) {
  if (array && array.length && element != null) {
    const index = array.indexOf(element)
    if (index !== -1) {
      array.splice(index, 1)
    }
  }
}

export default {
  name: 'ReportEditWorkTypes',
  components: {
    WarningBanner,
    Table,
    RequestWorkTypeIncludedInWorkPackagesIndicator,
    RequestWorkTypeDoneIndicator
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    reportWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    reportWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    reportWorkTypesToRemove: {
      type: Array,
      default () {
        return []
      }
    },
    executorTypeKey: {
      type: String,
      default: null
    },
    serviceObjectType: {
      type: Object,
      default () {
        return null
      }
    },
    request: {
      type: Object,
      default () {
        return null
      }
    },
    isAudit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      modalWorkTypesOpened: false,
      selectedWorkTypes: [],
      selectedWorkTypesIds: [],
      readonlyWorkTypesIds: [],
      availableWorkTypesRaw: null, // Список доступных для данного отчёта работ (не преобразованный)

      multiReportColumnSelectionActive: false,
      multiReportRequests: null,
      multiReportRequestsSelected: null,

      columnsWorks: [
        {
          name: 'name',
          label: 'Название работы',
          align: 'left',
          field: 'name',
          classes: 'class-bordered',
          sortable: true,
          headerStyle: 'width: 800px; white-space: normal;'
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  },
  computed: {
    ...mapGetters({
      workTypes: 'getWorkTypes'
    }),
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    roleDispatcherOrHigher: function () {
      const user = this.$store.getters.getUser
      const roles = user.roles || {}
      return !!roles.root || !!roles.admin || !!roles.dispatcher
    },
    availableWorkTypes: function () { // Список доступных для данного отчёта работ (преобразованный)
      if (this.availableWorkTypesRaw && this.readonlyWorkTypesIds) {
        const availableWorkTypes = this.availableWorkTypesRaw.map(wt => {
          const workType = { ...wt }
          workType._disabled = wt._disabled || this.readonlyWorkTypesIds.includes(workType.id)
          return workType
        })
        return availableWorkTypes
      }
      return []
    }
  },
  watch: {
    workTypes: {
      handler: function () {
        this.prepareAvailableWorkTypes()
      },
      immediate: true
    }
  },
  methods: {
    prepareAvailableWorkTypes: function () {
      const workAreasKeys = this.request.assigneeWorkAreas && this.request.assigneeWorkAreas.length
        ? this.request.assigneeWorkAreas.map(wa => wa.key)
        : this.report && this.report.executorWorkAreas && this.report.executorWorkAreas.length
          ? this.report.executorWorkAreas.map(wa => wa.key)
          : null

      const allWorkTypes = JSON.parse(JSON.stringify(this.workTypes))
      let availableWorkTypes = this.request.filterWorkTypes(allWorkTypes, this.isAudit)
      if (workAreasKeys) {
        availableWorkTypes = availableWorkTypes.filter(wt => wt.workAreas ? wt.workAreas.some(wa => workAreasKeys.includes(wa)) : true)
      }

      const workPackagesFieldKey = this.executorTypeKey === 'contractor' ? 'workPackagesContractor' : 'workPackages'
      const workTypesFieldKey = this.executorTypeKey === 'contractor' ? 'workTypesContractor' : 'workTypes'

      const allWorkTypesFromReport = [...this.report[workTypesFieldKey]]
      this.report[workPackagesFieldKey].forEach(workPackage => {
        allWorkTypesFromReport.push(...workPackage.workTypes)
      })
      const allWorkTypesFromRequest = [...this.request[workTypesFieldKey]]
      this.request[workPackagesFieldKey].forEach(workPackage => {
        allWorkTypesFromRequest.push(...workPackage.workTypes)
      })

      // Добавляем работы, содержащиеся в отчёте, но не прошедшие фильтрацию
      let hasFilteredReportWorks = false
      for (const reportWorkType of allWorkTypesFromReport) {
        let workType = availableWorkTypes.find(wt => reportWorkType.id === wt.id)
        if (!workType) {
          workType = allWorkTypes.find(wt => reportWorkType.id === wt.id)
          if (workType) {
            workType._disabled = true
            availableWorkTypes.push(workType)
            hasFilteredReportWorks = true
          }
        }
      }
      if (hasFilteredReportWorks) {
        availableWorkTypes.sort((a, b) => a.name.localeCompare(b.name))
      }

      availableWorkTypes.forEach(wt => {
        const reportWorkType = allWorkTypesFromReport.find(reportWorkType => reportWorkType.id === wt.id)
        if (reportWorkType) {
          wt = Object.assign(wt, reportWorkType)
        }

        const requestWorkType = allWorkTypesFromRequest.find(requestWorkType => requestWorkType.id === wt.id)
        if (requestWorkType) {
          wt = Object.assign(wt, requestWorkType)
        }
      })
      this.availableWorkTypesRaw = availableWorkTypes
    },
    onEditWorkTypes: function () {
      const multiReportRequests = this.getMultiReportRequests()
      this.multiReportRequests = multiReportRequests

      if (this.multiReportColumnSelectionActive || !multiReportRequests) {
        if (multiReportRequests) {
          this.multiReportRequestsSelected = multiReportRequests.filter(request => request._selected)
        }

        this.editWorkTypes()
      } else {
        this.selectMultiReportRequests(multiReportRequests, multiReportRequestsSelected => {
          if (multiReportRequestsSelected.length) {
            this.multiReportRequestsSelected = multiReportRequestsSelected
            this.editWorkTypes()
          }
        })
      }
    },
    editWorkTypes: function () {
      const reportWorkTypesConfig = this.getReportWorkTypes()
      this.selectedWorkTypes = reportWorkTypesConfig.workTypes
      this.selectedWorkTypesIds = reportWorkTypesConfig.workTypesIdsForSelectedRequests

      this.readonlyWorkTypesIds = reportWorkTypesConfig.readonlyWorkTypesIds
      this.modalWorkTypesOpened = true
    },
    onSaveWorkTypesSelection: async function () {
      const selectedWorkTypesIds = this.selectedWorkTypes.map(workType => workType.id)

      const reportStandaloneWorkTypes = this.reportWorkTypes ? this.reportWorkTypes.filter(workType => workType.includedInCurrentReport).slice() : []
      const reportAllWorkTypes = reportStandaloneWorkTypes.slice()
      const reportAllWorkTypesIds = reportAllWorkTypes.map(workType => workType.id)
      if (this.reportWorkPackages) {
        this.reportWorkPackages.forEach(workPackage => {
          workPackage.workTypes.forEach(workType => {
            if (workType.includedInCurrentReport && !reportAllWorkTypesIds.includes(workType.id)) {
              reportAllWorkTypes.push(workType)
              reportAllWorkTypesIds.push(workType.id)
            }
          })
        })
      }

      // Фильтруем старые записи.
      const currentWorkTypes = []
      const currentStandaloneWorkTypes = []
      let reportWorkTypesToRemove = this.reportWorkTypesToRemove.slice()
      const workTypesRemoved = []
      for (const workType of reportAllWorkTypes) {
        if (selectedWorkTypesIds.includes(workType.id)) {
          currentWorkTypes.push(workType)
          if (reportStandaloneWorkTypes.includes(workType)) {
            currentStandaloneWorkTypes.push(workType)
          }
        } else {
          workTypesRemoved.push(workType)
        }
      }

      // Добавляем новые записи.
      const newWorkTypes = []
      for (const selectedWorkTypeId of selectedWorkTypesIds) {
        const includedInWorkTypes = currentWorkTypes.find(workType => workType.id === selectedWorkTypeId)
        const includedInWorkPackages = !!this.reportWorkPackages.find(reportWorkPackage => {
          return !!reportWorkPackage.workTypes.find(workType => workType.id === selectedWorkTypeId && workType.includedInCurrentReport)
        })

        if (!includedInWorkTypes && !includedInWorkPackages) {
          const workTypeSelected = this.selectedWorkTypes.find(workType => workType.id === selectedWorkTypeId)
          let requestsIds = null
          if (workTypeSelected && workTypeSelected.requests) {
            requestsIds = workTypeSelected.requests.slice()
          }
          // Проверяем, что работа не была удалена ранее
          let workType = reportWorkTypesToRemove.find(workType => workType.id == selectedWorkTypeId)
          if (workType) {
            reportWorkTypesToRemove = reportWorkTypesToRemove.filter(workType => workType.id != selectedWorkTypeId)
            if (requestsIds) {
              workType.requests = requestsIds
            }
          } else {
            workType = this.getWorkTypeToAdd(selectedWorkTypeId, requestsIds)
          }
          if (workType) {
            newWorkTypes.push(workType)
          }
        }
      }

      let newWorkTypesWithResults = []
      if (newWorkTypes && newWorkTypes.length) {
        newWorkTypesWithResults = await this.getValueForWorkTypes(newWorkTypes)
        newWorkTypesWithResults.forEach(workType => prepareReportWork(workType, this.report, this.executorTypeKey))

        const newWorkTypesInOldPackages = []
        for (const reportWorkPackage of this.reportWorkPackages) {
          for (let i = 0; i < reportWorkPackage.workTypes.length; i++) {
            const workType = reportWorkPackage.workTypes[i]
            const newWorkType = newWorkTypesWithResults.find(newWorkType => newWorkType.id === workType.id)
            if (newWorkType) {
              reportWorkPackage.workTypes.splice(i, 1, newWorkType)
              newWorkTypesInOldPackages.push(newWorkType)
            }
          }
        }
        newWorkTypesWithResults = newWorkTypesWithResults.filter(workType => !newWorkTypesInOldPackages.includes(workType))
      }

      for (const workType of workTypesRemoved) {
        // if (workType._initial != null) { // значит, работа была в списке изначально (т.е. не была добавлена без сохранения)
        reportWorkTypesToRemove.push(workType)

        for (const reportWorkPackage of this.reportWorkPackages) {
          for (let i = 0; i < reportWorkPackage.workTypes.length; i++) {
            const workPackageWorkType = reportWorkPackage.workTypes.find(workPackageWorkType => workPackageWorkType.id === workType.id)
            if (workPackageWorkType && workPackageWorkType.includedInCurrentReport) {
              workPackageWorkType.includedInCurrentReport = false
              workPackageWorkType.done = workPackageWorkType.donePreviously
              workPackageWorkType.donePartially = workPackageWorkType.donePartiallyPreviously
              workPackageWorkType.donePreviously = false // TODO зачитать с сервера всю работу в формате уже удаленной
              workPackageWorkType.donePartiallyPreviously = false

              if (workPackageWorkType.historyRecords) {
                workPackageWorkType.historyRecords = workPackageWorkType.historyRecords.filter(record => !record.current)
              }
              if (workPackageWorkType.technologicalOperations) {
                for (const technologicalOperation of workPackageWorkType.technologicalOperations) {
                  technologicalOperation.done = technologicalOperation.donePreviously
                  technologicalOperation.donePreviously = false

                  if (technologicalOperation.historyRecords) {
                    technologicalOperation.historyRecords = technologicalOperation.historyRecords.filter(record => !record.current)
                  }
                  if (technologicalOperation.workResultsTypes) {
                    for (const workResultType of technologicalOperation.workResultsTypes) {
                      if (workResultType.historyRecords) {
                        workResultType.historyRecords = workResultType.historyRecords.filter(record => !record.current)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.$emit('work-types', { workTypes: [...currentStandaloneWorkTypes, ...newWorkTypesWithResults], workTypesToRemove: reportWorkTypesToRemove })
      this.onCloseWorkTypesModal()
    },
    getValueForWorkTypes: function (workTypes) {
      const params = new URLSearchParams()
      const selectedMultiReportIds = this.getSelectedMultiReportIds()
      params.append('id', selectedMultiReportIds && selectedMultiReportIds.length ? selectedMultiReportIds.join(',') : this.report.id)
      params.append('workTypeId', workTypes.map(workType => workType.id).join(','))
      params.append('contractor', this.executorTypeKey === 'contractor')
      params.append('addHistory', !this.mobile)

      return axiosGet({
        url: 'service/delta/report/getWorksToAdd?' + params.toString(),
        onSuccess: (response) => {
          const workTypesWithResults = response.data.result || []

          // Проставляем параметры работы, вычисляемые ранее на клиенте
          const params = ['isNew', 'executorTypeKey', 'requests', 'includedInCurrentReport']
          for (const workTypeWithResult of workTypesWithResults) {
            const workType = workTypes.find(wT => workTypeWithResult.id === wT.id)
            if (workType) {
              params.forEach(param => {
                workTypeWithResult[param] = workType[param]
              })
            }
          }
          return workTypesWithResults
        },
        onFailure: 'Ошибка загрузки результатов работ'
      })
    },
    getWorkTypeToAdd: function (workTypeId, requestsIds) {
      let workType = this.availableWorkTypes.find(workType => workType.id === workTypeId)

      if (workType) {
        workType = JSON.parse(JSON.stringify(workType))
        if (requestsIds) {
          workType.requests = requestsIds
        }
        workType.includedInCurrentReport = true
        Object.defineProperty(workType, 'executorTypeKey', {
          value: this.executorTypeKey || null,
          writable: false,
          enumerable: false,
          configurable: true
        })
        Object.defineProperty(workType, 'isNew', {
          value: true,
          writable: false,
          enumerable: false,
          configurable: true
        })
        return workType
      }
      return null
    },
    onCloseWorkTypesModal: function () {
      this.selectedWorkTypesIds = []
      this.modalWorkTypesOpened = false
    },
    getReportWorkTypes: function () {
      const reportAllWorkTypes = this.reportWorkTypes ? this.reportWorkTypes.filter(workType => workType.includedInCurrentReport).slice() : []
      const reportAllWorkTypesIds = reportAllWorkTypes.map(workType => workType.id)
      const readonlyWorkTypesIds = []
      if (this.reportWorkPackages) {
        this.reportWorkPackages.forEach(workPackage => {
          workPackage.workTypes.forEach(workType => {
            if (workType.includedInCurrentReport && !reportAllWorkTypesIds.includes(workType.id)) {
              reportAllWorkTypes.push(workType)
              reportAllWorkTypesIds.push(workType.id)
              // readonlyWorkTypesIds.push(workType.id) // работы из комплекса нельзя исключить
            }
          })
        })
      }
      reportAllWorkTypes.forEach(workType => {
        // выполненные или частично выполненные работы из нельзя исключить, без доступа по ролям нельзя исключить
        if (!readonlyWorkTypesIds.includes(workType.id) && (!this.hasWorkTypeAccess(workType) || workType.includedInCurrentReport && (workType.done || workType.donePartially))) {
          readonlyWorkTypesIds.push(workType.id)
        }
      })

      let reportWorkTypesForSelectedRequests
      let reportWorkTypesIdsForSelectedRequests
      const requestsIds = this.getSelectedMultiReportRequestsIds()
      if (requestsIds) {
        reportWorkTypesForSelectedRequests = reportAllWorkTypes.filter(workType => {
          if (!workType.requests) {
            return true // Если работа не привязана к заявкам
          } else {
            for (const requestId of requestsIds) {
              if (workType.requests.includes(requestId)) {
                return true // Если хотя бы одна заявка содержит работу
              }
            }
            return false
          }
        })

        reportWorkTypesIdsForSelectedRequests = reportWorkTypesForSelectedRequests.map(workType => workType.id)
      } else {
        reportWorkTypesForSelectedRequests = reportAllWorkTypes.slice()
        reportWorkTypesIdsForSelectedRequests = reportAllWorkTypesIds.slice()
      }

      return {
        workTypes: reportAllWorkTypes,
        workTypesIds: reportAllWorkTypesIds,
        workTypesForSelectedRequests: reportWorkTypesForSelectedRequests,
        workTypesIdsForSelectedRequests: reportWorkTypesIdsForSelectedRequests,
        readonlyWorkTypesIds
      }
    },
    hasWorkTypeAccess: function (workType) {
      if (this.roleDispatcherOrHigher) {
        return true
      } else if (workType.role == null || workType.role === 'undefined' || workType.role === 'brigadier' || workType.role === 'brigademember') {
        return true
      }
      return false
    },
    selectMultiReportRequests: function (multiReportRequests, callback) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        contentWidth: 800,
        headerLabel: 'Выбор отчётов сводного отчёта',
        contentComponent: ReportMultiReportSelector,
        contentProps: {
          multiReportRequests: multiReportRequests
        },
        componentHandlers: {
          apply: (multiReportRequestsSelected) => {
            dialog.hide()

            callback(multiReportRequestsSelected)
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },

    onSelectWorkType: function (workTypeData) {
      const requestsIds = this.getSelectedMultiReportRequestsIds()
      this.selectWorkType(workTypeData, requestsIds, workTypeData.isChecked)
    },
    selectWorkType: function (workTypeData, requestsIds, selected) {
      const index = this.selectedWorkTypes.findIndex(workType => workType.id === workTypeData.id)
      if (index !== -1) { // Работа уже добавлена в отчёт
        const workType = this.selectedWorkTypes[index]
        if (selected) {
          if (requestsIds) {
            // => добавляем заявки в работу
            if (!workType.requests) {
              workType.requests = []
            }
            const addedRequestsIds = []
            for (const requestId of requestsIds) {
              if (!workType.requests.includes(requestId)) {
                workType.requests.push(requestId)
                addedRequestsIds.push(requestId)
              }
            }
            console.log('Заявки добавлены в работу: ', workType.name, addedRequestsIds)
          } else {
            throw new Error('Ошибка выбора элемента: элемент уже выбран')
          }
          if (this.selectedWorkTypesIds.includes(workTypeData.id)) {
            this.selectedWorkTypesIds.push(workTypeData.id)
          }
        } else {
          if (requestsIds) {
            // Удаляем заявки из работы
            const deletedRequestsIds = []
            for (const requestId of requestsIds) {
              if (workType.requests.includes(requestId)) {
                deleteElementFromArray(workType.requests, requestId)
                deletedRequestsIds.push(requestId)
              }
            }
            console.log('Заявки удалены из работы: ', workType.name, deletedRequestsIds)

            // Удаляем работу, если она не привязана ни к одной заявке
            if (workType.requests.length === 0) {
              this.selectedWorkTypes.splice(index, 1)
              console.log('Работа удалена: ', workType.name)
            }
          } else {
            // Удаляем работу
            this.selectedWorkTypes.splice(index, 1)
            console.log('Работа удалена: ', workType.name)
          }
          deleteElementFromArray(this.selectedWorkTypesIds, workTypeData.id)
        }
      } else { // Работа еще не была включена в отчёт (и ни в одну заявку) => добавляем работу
        const workType = this.getWorkTypeToAdd(workTypeData.id, requestsIds)
        if (workType) {
          this.selectedWorkTypes.push(workType)
          this.selectedWorkTypesIds.push(workTypeData.id)

          console.log('Работа добавлена: ', workType.name)
          if (requestsIds) {
            console.log('Заявки добавлены в работу: ', workType.name, requestsIds)
          }
        }
      }
    },
    isWorkTypeInRequest: function (workTypeData, request) {
      if (workTypeData.isChecked) {
        const workType = this.selectedWorkTypes.find(workType => workType.id === workTypeData.id)
        if (workType && workType.requests) {
          return workType.requests.includes(request.id)
        }
      }
      return false
    },
    changeWorkTypeRequest: function (workTypeData, request, selected) {
      if (this.readonlyWorkTypesIds.includes(workTypeData.id)) {
        return
      }

      this.selectWorkType(workTypeData, [request.id], selected)
    },

    getMultiReportRequests: function () {
      const requestId = this.report.requestId
      if (requestId && typeof requestId === 'object' && Object.keys(requestId).length > 1) {
        // eslint-disable-next-line no-useless-escape
        const regExp = new RegExp('\.*№(\.*)\/\.*', 'i')
        const multiReportRequests = this.report.reports.map(report => {
          const requestNumber = regExp.exec(report.name)[1]
          return {
            id: requestId[report.id],
            name: 'Заявка №' + requestNumber,
            number: requestNumber,
            reportId: report.id,
            reportName: report.name,
            descr: null,
            type: null,
            _selected: true
          }
        })
        if (multiReportRequests.length) {
          return multiReportRequests
        }
      }
      return null
    },
    getSelectedMultiReportIds: function () {
      if (this.multiReportRequestsSelected) {
        return this.multiReportRequestsSelected.map(request => request.reportId)
      }
      return null
    },
    getSelectedMultiReportRequestsIds: function () {
      if (this.multiReportRequestsSelected) {
        return this.multiReportRequestsSelected.map(request => request.id)
      }
      return null
    },
    getWorkPackagesWithWorkType: function (workType) {
      return this.reportWorkPackages
        .filter(wP => wP.workTypes
          .map(wT => wT.id)
          .includes(workType.id))
        .map(wP => {
          return {
            name: wP.name,
            id: wP.id
          }
        })
    }
  }
}

